/**
 * 점검 관리 API
 */
import { apiClient } from "@/shared/api/client";
import { getItem } from "@/shared/utils/storage";
import {
    GetMaintenanceListResponseDto,
    GetActiveMaintenanceResponseDto,
    CreateMaintenanceRequestDto,
    UpdateMaintenanceRequestDto,
    MaintenanceResponseDto
} from "../types/maintenance.types";
import { MAINTENANCE_BASE_PATH } from "../constants/maintenance.constants";

export const maintenanceApi = {
    /**
     * 점검 목록 조회
     */
    getMaintenanceList: async (): Promise<GetMaintenanceListResponseDto> => {
        const response = await apiClient.get<GetMaintenanceListResponseDto>(`${MAINTENANCE_BASE_PATH}/list`);
        return response.data;
    },

    /**
     * 현재 활성화된 점검 조회
     */
    getActiveMaintenance: async (): Promise<GetActiveMaintenanceResponseDto> => {
        const response = await apiClient.get<GetActiveMaintenanceResponseDto>(`${MAINTENANCE_BASE_PATH}/active`);
        return response.data;
    },

    /**
     * 점검 등록
     */
    createMaintenance: async (request: CreateMaintenanceRequestDto): Promise<MaintenanceResponseDto> => {
        const insUser = getItem<string>('USER_ID');
        const requestWithUser = { ...request, insUser: insUser || '' };
        const response = await apiClient.post<MaintenanceResponseDto>(`${MAINTENANCE_BASE_PATH}/create`, requestWithUser);
        return response.data;
    },

    /**
     * 점검 수정
     */
    updateMaintenance: async (request: UpdateMaintenanceRequestDto): Promise<MaintenanceResponseDto> => {
        const updUser = getItem<string>('USER_ID');
        const requestWithUser = { ...request, updUser: updUser || '' };
        const response = await apiClient.post<MaintenanceResponseDto>(`${MAINTENANCE_BASE_PATH}/update`, requestWithUser);
        return response.data;
    },

    /**
     * 점검 삭제 (비활성화)
     */
    deleteMaintenance: async (seqNo: number): Promise<MaintenanceResponseDto> => {
        const updUser = getItem<string>('USER_ID');
        const response = await apiClient.post<MaintenanceResponseDto>(
            `${MAINTENANCE_BASE_PATH}/delete/${seqNo}`,
            null,
            { params: { updUser: updUser || '' } }
        );
        return response.data;
    }
};
